<template>
  <FreeModal :name="modalName" with-blackout>
    <template #header>
      <h3 class="text-text-neutral-primary text-center text-lg font-semibold">
        {{ title }}
      </h3>
    </template>
    <template #default="{ hide }">
      <div class="mt-1">
        <p
          class="text-text-neutral-tertiary whitespace-pre-line text-center text-sm font-medium"
        >
          {{ $t('search.directFlights.changeTimeModal.message') }}
        </p>
        <div class="mt-6 flex space-x-2">
          <FreeButton type="button" class="gray-button flex-grow" @click="hide">
            {{ $t('search.directFlights.changeTimeModal.cancel') }}
          </FreeButton>
          <FreeButton
            type="button"
            class="green-main-button flex-grow"
            @click="onAgree(hide)"
          >
            {{ $t('search.directFlights.changeTimeModal.ok') }}
          </FreeButton>
        </div>
      </div>
    </template>
  </FreeModal>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { useI18n } from 'vue-i18n';
  import { controllerModel } from 'shared';
  import { FreeButton, FreeModal } from 'freedom-shared';

  const props = defineProps<{
    modalName: string;
  }>();

  const emit = defineEmits<{
    (e: 'onAgree'): void;
  }>();

  const { t } = useI18n();
  const modal = controllerModel.useModal();

  const params = computed(() => modal.getParams(props.modalName) || {});
  const title = computed(() => {
    const direction = (params.value.changingDirection as 0 | 1) ?? 0;
    const key =
      direction === 0
        ? 'search.directFlights.changeTimeModal.titleSecond'
        : 'search.directFlights.changeTimeModal.titleFirst';
    return t(key);
  });

  const onAgree = (hide: () => void) => {
    emit('onAgree');
    hide();
  };
</script>
